'use client';

type Footnote = {
	id: string;
	content: string;
};

export type IBlockFootnotes = {
	attrs: {
		footnotes?: Footnote[];
		className?: string;
	};
};

/**
 * Renders the footnote reference list for core/footnotes. The list is sourced
 * from the `footnotes` post meta (attached in the theme REST layer) since the
 * block itself is dynamic and carries no static content. Each item links back
 * to its inline marker via the `#<id>-link` anchor that WordPress emits.
 */
export default function BlockFootnotes({ attrs }: IBlockFootnotes) {
	const { footnotes } = attrs || {};

	if (!footnotes?.length) return <></>;

	return (
		<ol className="wp-block-footnotes">
			{footnotes.map((footnote) => (
				<li key={footnote.id} id={footnote.id}>
					<span dangerouslySetInnerHTML={{ __html: footnote.content }} />{' '}
					<a href={`#${footnote.id}-link`} aria-label="Back to content">
						↩︎
					</a>
				</li>
			))}
		</ol>
	);
}
